// src/utils/dates.js — shared date utilities and app seed state
// Imported by App.js, DashboardPage, TasksPage, CalendarPage, VinylPage,
// FinancePage, MorningBriefPage, ChatPage, ListsSection, and all utils.

// ── TODAY ─────────────────────────────────────────────────────────────────────
export const TODAY = new Date().toISOString().slice(0, 10);

export const TODAY_DISP = new Date().toLocaleDateString('en-US', {
  weekday: 'long', month: 'long', day: 'numeric',
});

// ── df — days from today (positive = future, negative = past) ─────────────────
export function df(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr + 'T12:00:00');
  const t = new Date(TODAY + 'T12:00:00');
  return Math.round((d - t) / 86400000);
}

// ── addDays — returns YYYY-MM-DD string N days from a given date ──────────────
export function addDays(dateStr, n) {
  const d = new Date(dateStr + 'T12:00:00');
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}

// ── uc — uppercase first letter ───────────────────────────────────────────────
export function uc(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// ── fetchWithTimeout — fetch with AbortController timeout ────────────────────
export async function fetchWithTimeout(url, opts = {}, ms = 8000) {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), ms);
  try {
    const res = await fetch(url, { ...opts, signal: ctrl.signal });
    return res;
  } finally {
    clearTimeout(timer);
  }
}

// ── DUE_OPTIONS — task due date presets ──────────────────────────────────────
export const DUE_OPTIONS = [
  { id: 'today',    label: 'today',     getDate: () => TODAY },
  { id: 'tomorrow', label: 'tomorrow',  getDate: () => addDays(TODAY, 1) },
  { id: 'thisWeek', label: 'this week', getDate: () => addDays(TODAY, 3) },
  { id: 'nextWeek', label: 'next week', getDate: () => addDays(TODAY, 7) },
  { id: 'custom',   label: 'custom',    getDate: () => TODAY },
];

// ── DUE_TO_BUCKET — maps dueOption id to task bucket ─────────────────────────
export const DUE_TO_BUCKET = {
  today:    'today',
  tomorrow: 'today',
  thisWeek: 'thisWeek',
  nextWeek: 'later',
  custom:   'later',
};

// ── SEED — default app state ──────────────────────────────────────────────────
export const SEED = {
  profile:   { name: '', timezone: 'America/Chicago', onboarded: false },
  tasks:     [],
  lists:     [{ id: 'l1', title: 'personal' }, { id: 'l2', title: 'work' }],
  routines:  [],
  quickLists:[],
  events:    [],
  finance:   [],
  income:    [],
  goals:     [],
  vinyl:     [],
  decisions: [],
  reminders: [],
  timeline:  [],
  contacts:  [],
  workouts:  [],
  trainRoutines: [],
  memories:  [],
  coachHistory: [],
  pendingEmailActions: [],
  raceName:  '',
  raceDate:  '',
  anthropicKey: '',
  discogsToken: '',
  prefs: {
    pushEnabled:  false,
    shiftMode:    false,
    pulseMetrics: ['tasks', 'payday', 'workouts'],
  },
  theme: 'dark',
};
